import {Outlet, createFileRoute} from "@tanstack/react-router";
import {routeMessages} from "../../../../messages/routes.messages";

export const Route = createFileRoute("/_app/user-management/users")({
  component: () => <Outlet />,
  staticData: {
    meta: {
      labelDescriptor: routeMessages.users,
      moduleDescriptor: routeMessages.userManagement,
      nav: {order: 1, visible: true},
    },
  },
});
